import './index.css'
import React from 'react'
import ContextMenu from 'components/common/context-menu'
import Button from 'components/ui/button'
type Props = {
  items: ActionThumbItemType[]
}
export type ActionThumbItemType = {
  value: string
  label?: string
  renderIcon?: (...args: Array<any>) => any
  onClick?: (...args: Array<any>) => any
}

/**
 * A thumb action button with dropdown menu for track similarity feedback
 * @param items - Array of action items with labels, icons, and click handlers
 */
const ActionThumb = ({ items }: Props) => {
  const renderDropdown = ({ closeMenu }: { closeMenu?: () => void }) => {
    return items.map((item, index) => {
      const { renderIcon, value, label, onClick } = item
      return (
        <span
          key={value || index}
          className={'context-menu__option'}
          onClick={() => {
            if (onClick) onClick()
            if (closeMenu) closeMenu()
          }}
        >
          {renderIcon && (
            <div className="ActionThumb__Icon">{renderIcon()}</div>
          )}
          {label && label}
        </span>
      )
    })
  }

  const getMenuOffset = (top: number) => {
    if (top > window.innerHeight / 2) {
      return ['0', '-100%']
    }

    return ['0', '24px']
  }

  return (
    <ContextMenu
      getMenuOffset={getMenuOffset}
      buttonClassName="ActionThumb__Button"
      customButton={
        <Button
          appearance="icon"
          compact
          icon="thumbs-up"
          tooltip="Is this track similar?"
        />
      }
    >
      {props => renderDropdown(props)}
    </ContextMenu>
  )
}

export default React.memo<Props>(ActionThumb)
